import { View } from 'react-native'
import { tv } from 'tailwind-variants'
import { z } from 'zod'

import { colorUnion } from '@/cms/helperTypes'
import { Instagram } from '@/components/renderers/MultiColoredImage/Instagram'
import { Linkedin } from '@/components/renderers/MultiColoredImage/Linkedin'
import Medium from '@/components/renderers/MultiColoredImage/Medium'
import Stars from '@/components/renderers/MultiColoredImage/Stars'
import { TikTok } from '@/components/renderers/MultiColoredImage/TikTok'
import { Twitter } from '@/components/renderers/MultiColoredImage/Twitter'
import { YouTube } from '@/components/renderers/MultiColoredImage/YouTube'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const Images = {
  stars: Stars,
  instagram: Instagram,
  tiktok: TikTok,
  twitter: Twitter,
  linkedin: Linkedin,
  medium: Medium,
  youtube: YouTube,
}

const multiColoredImage = z.object({
  _type: z.literal('multiColoredImage'),
  image: z.enum(['stars', 'instagram', 'twitter', 'linkedin', 'medium', 'youtube', 'tiktok']),
  color: colorUnion.optional(),
})

const imageStyles = tv({
  slots: {
    container: 'flex flex-col items-center',
  },
})
export const MultiColoredImage = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = multiColoredImage.parse(props.node.value)
  const color = value?.color ?? 'brandDark'

  const imageSrc = value?.image ?? null
  const styles = imageStyles()

  if (!imageSrc) {
    return null
  }

  const ImageComponent = Images[imageSrc]

  return (
    <View className={styles.container()}>
      {ImageComponent ? <ImageComponent color={color} /> : null}
    </View>
  )
}
